import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { changeUserPassword } from "../../../redux/Slices/UsersSlice";
import { FaArrowRight, FaKey } from "react-icons/fa";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useTitle } from "../../../shared/hooks/TitleContext";
import i18n from "../../../i18n/i18n";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { setTitle } = useTitle();
  const { t } = useTranslation("global");
  const isRTL = i18n.language === "ar";
  const textAlign = isRTL ? "right" : "left";
  const dir = isRTL ? "rtl" : "ltr";

  const [formData, setFormData] = useState({
    password: "",
    password_confirmation: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTitle("users.changePasswordTitle");
  }, [setTitle]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!formData.password) {
      toast.error(
        t("users.validation.password", {
          defaultValue: "الرجاء إدخال كلمة المرور",
        }),
        { rtl: isRTL },
      );
      return;
    }

    if (formData.password !== formData.password_confirmation) {
      toast.error(
        t("users.validation.passwordMatch", {
          defaultValue: "كلمات المرور غير متطابقة",
        }),
        { rtl: isRTL },
      );
      return;
    }

    setIsLoading(true);
    try {
      const result = await dispatch(
        changeUserPassword({ userId: id, passwordData: formData }),
      );
      if (changeUserPassword.fulfilled.match(result)) {
        toast.success(
          t("users.changePassword.success", {
            defaultValue: "تم تغيير كلمة المرور بنجاح",
          }),
          { rtl: isRTL },
        );
        navigate("/users");
      } else {
        toast.error(
          result.payload ||
            t("users.changePassword.error", {
              defaultValue: "فشل تغيير كلمة المرور",
            }),
          { rtl: isRTL },
        );
      }
    } catch (err) {
      toast.error(
        err.message ||
          t("users.changePassword.error", {
            defaultValue: "فشل تغيير كلمة المرور",
          }),
        { rtl: isRTL },
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#14263b",
        minHeight: "calc(100vh - 80px)",
        color: "white",
        direction: dir,
        textAlign,
      }}
    >
      <div style={{ marginBottom: "30px" }}>
        <button
          onClick={() => navigate("/users")}
          style={{
            backgroundColor: "#666",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
            fontSize: "14px",
            fontFamily:
              '"Times New Roman Bold", "Times New Roman", "Times", serif',
            flexDirection: isRTL ? "row" : "row-reverse",
          }}
        >
          <FaArrowRight />
          {t("common.back", { defaultValue: "الرجوع" })}
        </button>
      </div>

      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: "#1b3350",
          border: "1px solid #333",
          borderRadius: "12px",
          padding: "32px",
          width: "100%",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "white",
              fontFamily:
                '"Times New Roman Bold", "Times New Roman", "Times", serif',
            }}
          >
            {t("sign.password", { defaultValue: "كلمة المرور الجديدة" })}{" "}
            <span style={{ color: "#dc3545" }}>*</span>
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#1a1f2e",
              border: "1px solid #333",
              borderRadius: "8px",
              color: "white",
              fontSize: "14px",
              boxSizing: "border-box",
              direction: dir,
              fontFamily:
                '"Times New Roman Bold", "Times New Roman", "Times", serif',
            }}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: "bold",
              color: "white",
              fontFamily:
                '"Times New Roman Bold", "Times New Roman", "Times", serif',
            }}
          >
            {t("sign.confirmPassword", { defaultValue: "تأكيد كلمة المرور" })}{" "}
            <span style={{ color: "#dc3545" }}>*</span>
          </label>
          <input
            type="password"
            name="password_confirmation"
            value={formData.password_confirmation}
            onChange={handleChange}
            required
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#1a1f2e",
              border: "1px solid #333",
              borderRadius: "8px",
              color: "white",
              fontSize: "14px",
              boxSizing: "border-box",
              direction: dir,
              fontFamily:
                '"Times New Roman Bold", "Times New Roman", "Times", serif',
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
        >
          <button
            type="submit"
            disabled={isLoading}
            style={{
              backgroundColor: isLoading ? "#666" : "#AC2000",
              color: "white",
              border: "none",
              padding: "12px 24px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "bold",
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.6 : 1,
              fontFamily:
                '"Times New Roman Bold", "Times New Roman", "Times", serif',
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {isLoading
              ? t("common.saving", { defaultValue: "جاري الحفظ..." })
              : t("btns.save", { defaultValue: "حفظ" })}
          </button>
          <button
            type="button"
            onClick={() => navigate("/users")}
            style={{
              backgroundColor: "#6c757d",
              color: "white",
              border: "none",
              padding: "12px 24px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "bold",
              cursor: "pointer",
              fontFamily:
                '"Times New Roman Bold", "Times New Roman", "Times", serif',
            }}
          >
            {t("btns.cancel", { defaultValue: "إلغاء" })}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
